import { render, staticRenderFns } from "./Codes.vue?vue&type=template&id=2c2e1154&scoped=true"
import script from "./Codes.vue?vue&type=script&lang=js"
export * from "./Codes.vue?vue&type=script&lang=js"
import style0 from "./Codes.vue?vue&type=style&index=0&id=2c2e1154&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e1154",
  null
  
)

export default component.exports